<template>
  <div class="iq-card-body iq-card">
    <div class="d-flex align-items-center flex-wrap justify-content-around p-2">
      <b-form-group label="Select status">
        <b-form-select plain v-model="filter.status">
          <b-form-select-option
            v-for="type in statusOptions"
            :value="type.value"
            :key="type.value"
            >{{ type.text }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <SearchUsersForm
        label="Booked by"
        :business-id="businessId"
        ref="SearchUsersByForm"
        :show-add-user="false"
        :reservation-errors="[]"
        :is-required="false"
        @setUser="
          userDetails =>
            (filter.reserved_by_id = userDetails ? userDetails.id : null)
        "
      />

      <SearchUsersForm
        label="Booked for"
        :business-id="businessId"
        ref="SearchUsersForForm"
        :show-add-user="false"
        :reservation-errors="[]"
        :is-required="false"
        @setUser="
          userDetails =>
            (filter.reserved_for_id = userDetails ? userDetails.id : null)
        "
      />

      <SearchUsersForm
        label="Followed by"
        :business-id="businessId"
        ref="SearchUsersFollowerForm"
        :show-add-user="false"
        :reservation-errors="[]"
        :is-required="false"
        @setUser="
          userDetails =>
            (filter.follower_id = userDetails ? userDetails.id : null)
        "
      />
    </div>
  </div>
</template>
<script>
import { ReservationStatuses } from "@/config/constant";
import SearchUsersForm from "./SearchUsersForm.vue";
export default {
  name: "Filters",
  components: { SearchUsersForm },
  props: ["businessId"],
  data() {
    return {
      filter: {
        status: "",
        reserved_for_id: null,
        reserved_by_id: null,
        follower_id: null
      },
      statusOptions: [
        { text: "Active", value: "" },
        { text: "Cancelled", value: ReservationStatuses.canceled }
      ]
    };
  },
  watch: {
    filter: {
      deep: true,
      handler(value) {
        console.log(value);
        this.$emit("update", value);
      }
    }
  }
};
</script>

<style scoped></style>
